import { Typography } from "@suraasa/placebo-ui"
import clsx from "clsx"
import PageContainer from "components/PageContainer"
import { ReactNode } from "react"

const TopHeadingBar = ({
  heading,
  subheading,
  endSlot,
  children,
  preHeadingSlot,
  renderBorder,
}: {
  heading: string | ReactNode
  subheading?: string
  endSlot?: ReactNode
  children?: ReactNode
  preHeadingSlot?: ReactNode
  renderBorder?: boolean
}) => {
  return (
    <div
      id="top-heading-bar"
      className={clsx(
        "bg-surface-500",
        renderBorder ? "border-b border-[#e2e8f0]" : "border-none"
      )}
    >
      <PageContainer>
        <div className="flex flex-wrap items-center justify-between">
          <div className="my-2">
            {preHeadingSlot && preHeadingSlot}
            <Typography variant="title2">{heading}</Typography>
            {subheading && (
              <Typography
                variant="largeBody"
                className="mt-0.5 text-onSurface-500"
              >
                {subheading}
              </Typography>
            )}
          </div>

          {endSlot && endSlot}
        </div>
        {children}
      </PageContainer>
    </div>
  )
}

export default TopHeadingBar
